import { useEffect, useState } from 'react';
import { fetchPublicFeatureFlags } from '../services/featureFlagsApi';
import { isPublicFeatureFlagEnabled } from '../constants/featureFlags';

export function usePublicFeatureFlag(flagKey) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const flags = await fetchPublicFeatureFlags();
        if (mounted) {
          setEnabled(isPublicFeatureFlagEnabled(flags, flagKey));
        }
      } catch {
        if (mounted) {
          setEnabled(false);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [flagKey]);

  return { enabled, loading };
}
